<template>
  <div class="ma-4">
    <!--START INCIDENT TABLE-->
    <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs12>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12>
          <h3 class="text-center mb-5">Incident Reports Graph</h3>
          <v-divider class="ml-4 mr-4 mb-3"></v-divider>
        </v-flex>

        <v-flex xs12>
          <v-card
            class="ma-3 pa-3"
            elevation="0"
          >
            <v-layout row wrap>
              <v-flex xs12 md4 class="pa-1">
                <DatePicker
                  :default-date="filters.startDate"
                  v-model="filters.startDate"
                  label="Start Date"
                  @change="searchIncidents()"
                />
              </v-flex>

              <v-flex xs12 md4 class="pa-1">
                <DatePicker
                  :default-date="filters.endDate"
                  v-model="filters.endDate"
                  label="End Date"
                  @change="searchIncidents()"
                />
              </v-flex>

              <v-flex xs12 md4 class="pa-1 mb-2">
                <v-select
                  label="Select an Incident Type"
                  :items="incidentTypes"
                  item-text="Name"
                  item-value="Name"
                  v-model="filters.incidentType"
                  clearable
                  @change="searchIncidents()"
                ></v-select>
              </v-flex>

              <v-flex xs12 md4 class="pa-1 mb-2">
                <v-select
                  label="Select an Incident Category"
                  :items="incidentCategories"
                  item-text="Name"
                  item-value="Name"
                  v-model="filters.selectedIncidentCategory"
                  clearable
                  @change="searchIncidents()"
                ></v-select>
              </v-flex>

              <v-flex xs12 md4 class="pa-1 mb-2">
                <v-select
                  label="Select a Client"
                  :items="filteredClients"
                  item-text="Name"
                  item-value="_id"
                  v-model="filters.ClientID"
                  clearable
                  @change="searchIncidents()"
                ></v-select>
              </v-flex>
              <v-flex xs12 md4 class="pa-1 mb-2">
                <v-select
                  label="Select a Program"
                  :items="units"
                  item-text="Name"
                  item-value="Name"
                  v-model="filters.program"
                  clearable
                  @change="searchIncidents()"
                ></v-select>
              </v-flex>

              <v-row class="mt-5 mb-5" justify="center">
                <v-col xs12 sm4 class="text-center">
                  <v-btn
                    color="primary"
                    small
                    :disabled="isLoading"
                    @click="generateTimeDifferenceChartData()">
                    <v-icon left>mdi-clock</v-icon>
                    Time Difference Chart
                  </v-btn>
                </v-col>
                <v-col xs12 sm4 class="text-center">
                  <v-btn
                    color="primary"
                    small
                    :disabled="isLoading"
                    @click="generateIncidentTypeChartData()">
                    <v-icon left>mdi-chart-bar</v-icon>
                    Incident Type Graph
                  </v-btn>
                </v-col>
              </v-row>


            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pa-2">
          <v-data-table
            :headers="state === 'Utah' ? headers : nevadaHeaders"
            :items="incidents"
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Incident Reports"
            :items-per-page="100"
            :page="currentPage"
            :pageCount="pageCount"
            :server-items-length="itemCount"
            :options.sync="options"
          >
            <template v-slot:item.select="{ item }">
              <v-btn
                x-small
                class="white--text"
                color="#2b3990"
                @click="viewIncidentReport(item)"
              >
                View
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
    <!--END INCIDENT TABLE-->

    <!--START INCIDENT GRAPH DIALOG-->
    <v-dialog v-model="isTimeDifferenceChartDialogVisible" max-width="80%">
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">Viewing Time Difference Chart</span>
        </v-card-title>
        <v-card-text>
          <LineChart
            :loading="isLoading"
            :chart-data="timeDifferenceChartData"
            chart-id="timeDifferenceChart"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#2b3990" class="white--text" @click="isTimeDifferenceChartDialogVisible = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Bar Chart Dialog -->
    <v-dialog v-model="isIncidentTypeChartDialogVisible" max-width="80%">
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">Viewing Incident Type Chart</span>
        </v-card-title>
        <v-card-text>
          <BarChart
            :loading="isLoading"
            :chart-data="incidentTypeChartData"
            chart-id="incidentTypeChart"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#2b3990" class="white--text" @click="isIncidentTypeChartDialogVisible = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--END INCIDENT GRAPH DIALOG-->
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import LineChart from '../../components/shared/LineChart';
import BarChart from '../../components/shared/BarChart';
import {STATUS_ARRAY} from '@/enums/UserStatusEnum';
import DateTimeUtil from "../../../utils/date-time.util";
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";

const url = require("../../client_config/config").url;

export default {
  components: {
    DatePicker,
    LineChart,
    BarChart
  },
  data: () => ({
    headers: [
      {
        text: "Client",
        value: "ClientInfo.Name",
        sortable: true
      },
      {
        text: "Program",
        value: "Program",
        sortable: true
      },
      {
        text: "Incident Type",
        value: "Type",
        sortable: true
      },
      {
        text: "Notified",
        value: "ReportSubmitted"
      },
      {
        text: 'Incident Date and Approximate Time',
        align: 'start',
        value: 'IncidentDateTime',
        sortable: true
      },
      {
        text: 'Incident Discovered Date and Time',
        align: 'start',
        value: 'IncidentDiscovered',
      },
      {
        text: "Time Difference",
        value: "TimeDifference"
      },
      {
        text: '',
        value: "select",
        sortable: false
      }
    ],
    nevadaHeaders: [
      {
        text: "Client",
        value: "ClientInfo.Name",
        sortable: true
      },
      {
        text: "Program",
        value: "Program",
        sortable: true
      },
      {
        text: 'Incident Date',
        align: 'start',
        value: 'IncidentDateTime',
        sortable: true
      },
      {
        text: 'Incident Notification Date',
        align: 'start',
        value: 'ReportSubmittedDate',
      },
      {
        text: "Time Difference",
        value: "TimeDifference",
        sortable: false
      },
      {
        text: "Incident Type",
        value: "Type",
        sortable: true
      },
      {
        text: "Notified",
        value: "ReportSubmitted"
      },
      {
        text: '',
        value: "select",
        sortable: false
      }
    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    page: 'Incidents',
    category: ["Behavioral", "Medical", "Hospital", "Injury"],
    clients: [],
    incidents: [],
    units: [],
    startDate: '',
    endDate: '',
    ClientID: '',
    state: '',
    graphStartDateCalendarMenu: false,
    graphEndDateCalendarMenu: false,
    graphStartDate: '',
    graphEndDate: '',
    report: '',
    clientName: '',
    isLoading: false,
    program: '',
    states: ['Utah', 'Nevada'],
    userState: localStorage.getItem('userState'),
    userRole: localStorage.getItem('userRole'),
    isUtahIncidentReports: true,
    isTimeDifferenceChartDialogVisible: false,
    isIncidentTypeChartDialogVisible: false,
    // isIncidentReportViewDialogVisible: false,
    // isIncidentReportGraphDialogVisible: false,
    isLoadingIncidentsGraphData: false,
    timeDifferenceChartData: null,
    incidentTypeChartData: [],
    chartOptions: [],
    selectedUtahIncident: {},
    selectedNevadaIncident: {},
    nevadaIRTypes: ["Behavioral", "Medical", "Hospital", "Injury", "Allegations", "Property Damage"],
    utahIRTypes: ["Behavioral", "Medical", "Hospital", "Injury", "Property Damage"],
    incidentCategories: ["Abuse/Neglect/Exploitation", "Aspiration/Choking", "Behavior Intervention", "Compromised Environment", "Drug/Alcohol", "Elopement", "Fatality", "Hospital", "Injury", "Medication Errors", "Missing Person", "Physical Aggression", "Property Destruction", "Restrained", "Seizure", "Suicide Attempt/Threat", "Theft", "Other (describe)"],
    incidentTypes: [],
    selectedIncidentCategory: [],
    incidentType: '',
    dateRange: ['Last Year', 'Previous Month', 'Last 7 days'],
    selectedDateRange: '',
    tabs: null,
    currentPage: 1,
    pageCount: 1,
    itemCount: 0,
    options: {},
    clientStatus: "",
    clientStatuses: STATUS_ARRAY,
    filteredClients: [],
    filters: {
      startDate: '',
      endDate: '',
      incidentType: '',
      selectedIncidentCategory: '',
      program: '',
      clientStatus: '',
      ClientID: '',
    }
  }),

  watch: {
    options: {
      handler() {
        this.searchIncidents();
      },
      deep: true
    },
    clientStatus: function (val) {
      if (val === '' || val == null) {
        this.filteredClients = this.clients;
      } else {
        this.filteredClients = this.clients.filter((client) => client.Status === val);
      }
      this.filters.clientStatus = val;
    },
    filters: {
      handler() {
        this.setFilters();
      },
      deep: true
    }
  },

  created() {
    this.incidentTypes = this.userState === 'Utah' ? this.utahIRTypes : this.nevadaIRTypes;
    // Disabling the searchIncidents() function call here because of the watch options handler above
    // this.searchIncidents();
    this.getClients();
    this.getPrograms();
    this.getFilters();
  },

  methods: {
    initialize() {
      this.clients = [];
    },

    async getClients() {
      let params = {};
      let endpoint = `${url}/clients`;

      const companyIds = localStorage.getItem('userCompanies');

      params['Company:in'] = JSON.parse(companyIds);
      params['State'] = this.userState;

      await axios.get(endpoint, {params})
        .then((res) => {
          this.clients = res.data.clients;
          this.filteredClients = this.clients;
        });
    },

    async getPrograms() {
      await axios.get(`${url}/units/state/${this.userState}`)
        .then((res) => {
          this.units = res.data.units;
        });
    },

    getIncidents() {
      this.incidents = [];

      axios.get(`${url}/incidents`).then(async res => {
        this.incidents = res.data.incidents;
        this.isLoading = false;
      });
    },

    close() {
      this.seditInfo = false;
      this.passdialog = false;
      this.chgimg = false;
    },

    async searchIncidents() {
      this.isLoading = true;
      this.filters.program = this.filters.program || '';
      this.filters.startDate = this.filters.startDate || moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.filters.endDate = this.filters.endDate || moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.filters.ClientID = this.filters.ClientID || '';
      this.filters.incidentType = this.filters.incidentType || '';
      this.filters.incidentCategory = this.filters.selectedIncidentCategory || [];
      this.state = localStorage.getItem('userState');
      this.incidents = [];

      if (this.state === 'Utah') {
        this.incidents = await this.getUtahIncidentReports();
      } else if (this.state === 'Nevada') {
        this.incidents = await this.getNevadaIncidentReports();
      }

      this.isLoading = false;
    },

    async getUtahIncidentReports() {
      const urlEndpoint = `${url}/incidents/reports`;

      let {page, itemsPerPage, sortBy, sortDesc} = this.options;
      page = page || 1;
      itemsPerPage = itemsPerPage || 100;
      this.currentPage = page;

      this.program = this.program || '';
      this.ClientID = this.ClientID || '';
      this.incidentType = this.incidentType || '';

      const params = {
        page: page,
        limit: itemsPerPage,
        program: this.filters.program || '',
        startDate: DateTimeUtil.toUTCISOString(this.filters.startDate),
        endDate: DateTimeUtil.toUTCISOString(this.filters.endDate),
        clientID: this.filters.ClientID || '',
        state: this.state || '',
        clientStatus: this.filters.clientStatus || '',
        sortField: (sortBy && sortBy.length) ? sortBy[0] : '_id',
        sortDirection: (sortDesc && sortDesc.length && sortDesc[0]) ? 'desc' : 'asc',
        incidentType: this.filters.incidentType || '',
        incidentCategory: this.filters.selectedIncidentCategory || ''
      };

      const incidentsResponse = await axios.get(urlEndpoint, {params});

      console.log({incidentsResponse});

      const {docs, totalPages, totalDocs} = incidentsResponse.data;
      this.pageCount = totalPages;
      this.itemCount = totalDocs;
      let incidentReports = [];

      if (docs) {
        incidentReports = this.mapIncidents(docs);
      }

      return incidentReports;
    },

    async getNevadaIncidentReports() {
      let {page, itemsPerPage, sortBy, sortDesc} = this.options;
      page = page || 1;
      itemsPerPage = itemsPerPage || 100;
      this.currentPage = page;

      this.filters.program = this.filters.program || '';
      this.filters.ClientID = this.filters.ClientID || '';
      this.filters.incidentType = this.filters.incidentType || '';

      const params = {
        page: page,
        limit: itemsPerPage,
        program: this.filters.program || '',
        startDate: DateTimeUtil.toUTCISOString(this.filters.startDate),
        endDate: DateTimeUtil.toUTCISOString(this.filters.endDate),
        clientId: this.filters.ClientID || '',
        state: this.state || '',
        clientStatus: this.filters.clientStatus || '',
        sortField: (sortBy && sortBy.length) ? sortBy[0] : '_id',
        sortDirection: (sortDesc && sortDesc.length && sortDesc[0]) ? 'desc' : 'asc',
        incidentType: this.filters.incidentType
      };


      const incidentsResponse = await axios.get(`${url}/nevadaIncidents`, {params});
      const {docs, totalPages, totalDocs} = incidentsResponse.data.nevadaIncidents;
      this.pageCount = totalPages;
      this.itemCount = totalDocs;
      let incidentReports = [];

      if (docs) {
        incidentReports = this.mapIncidents(docs);
      }

      return incidentReports;
    },

    async viewIncidentsGraph() {
      if (this.isLoadingIncidentsGraphData) {
        alert('Still loading incidents graph data. Please wait...');
        return;
      }

      if (this.filters.startDate && this.filters.endDate) {
        this.startDate = DateTimeUtil.toStartOfDay(this.filters.startDate);
        this.endDate = DateTimeUtil.toEndOfDay(this.filters.endDate);

        await this.searchIncidents();
      }

      this.isLoadingIncidentsGraphData = true;
      // this.timeDifferenceChartData = this.generateTimeDifferenceChartData(this.incidents);
      this.incidentTypeChartData = this.generateIncidentTypeChartData(this.incidents);
      this.isIncidentReportGraphDialogVisible = true;
      this.isLoadingIncidentsGraphData = false;
    },

    printGraph() {
      let id = this.tabs === 0 ? 'timeDifferenceChart' : 'incidentTypeChart';
      let chartName = this.tabs === 0 ? 'Time Difference Chart' : 'Incident Type Chart';
      let timeDifferenceChartElement = document.getElementById(id).toDataURL();
      let html = `<html lang="en"><head><title></title></head><body><br><br><br><br><br><br><div align="center"><h3>${chartName}</h3><img src=${timeDifferenceChartElement} alt="" style="width: 75%"></div></body>`;

      let printWindow = window.open('', 'Print-Preview', 'height=auto,width=auto');
      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();

      setTimeout(() => printWindow.print(), 500);
    },

    async generateIncidentTypeChartData() {
      if (this.filters.startDate && this.filters.endDate) {
        this.startDate = DateTimeUtil.toStartOfDay(this.filters.startDate);
        this.endDate = DateTimeUtil.toEndOfDay(this.filters.endDate);

        await this.searchIncidents();
      }

      const incidents = this.incidents || [];
      const labels = [];
      const incidentTypes = [];
      const data = {};
      const datasets = [];
      this.isIncidentTypeChartDialogVisible = true;


      console.log({incidentsBar: incidents});

      incidents.forEach(incident => {
        if (incident.IncidentDateFormatted && labels.indexOf(incident.IncidentDateFormatted) < 0) {
          labels.push(incident.IncidentDateFormatted);
        }
        if (incident.Type && incidentTypes.indexOf(incident.Type) < 0) {
          incidentTypes.push(incident.Type);
        }
      });


      labels.forEach(label => {
        const datasetsPerDate = [];
        incidentTypes.forEach(incidentType => {
          datasetsPerDate.push({
            type: incidentType,
            count: 0
          });
        });
        data[label] = datasetsPerDate;
      });

      incidents.forEach(incident => {
        if (incident.IncidentDateFormatted && incident.Type) {
          const dateData = data[incident.IncidentDateFormatted];
          if (dateData && dateData.length) {
            let index = null;
            for (let i = 0; i < dateData.length; i++) {
              if (dateData[i].type === incident.Type) {
                index = i;
                break;
              }
            }
            if (index !== null) {
              dateData[index].count += 1;
            }
            data[incident.IncidentDateFormatted] = dateData;
          }
        }
      });

      const usedChartColors = [];
      incidentTypes.forEach(incidentType => {
        const incidentTypeNumbers = [];
        labels.forEach(label => {
          const dateEntry = data[label];
          dateEntry.forEach(entry => {
            if (entry.type === incidentType) {
              incidentTypeNumbers.push(entry.count);
            }
          });
        });

        const chartColor = this.getRandomColor(usedChartColors);
        usedChartColors.push(chartColor);

        const datasetItem = {
          label: incidentType,
          data: incidentTypeNumbers,
          borderColor: chartColor,
          backgroundColor: chartColor
        };
        datasets.push(datasetItem);
      });


      this.incidentTypeChartData = {
        labels: labels,
        datasets: datasets
      };
    },


    async generateTimeDifferenceChartData() {
      if (this.filters.startDate && this.filters.endDate) {
        this.startDate = DateTimeUtil.toStartOfDay(this.filters.startDate);
        this.endDate = DateTimeUtil.toEndOfDay(this.filters.endDate);

        await this.searchIncidents();
      }

      const incidents = this.incidents || [];
      const labels = [];
      const timeDifferencesInHours = [];

      incidents.forEach(incident => {
        labels.push(incident.IncidentDateTime);
        timeDifferencesInHours.push(Number(incident.TimeDifferenceInHours.toFixed(2)));
      });

      this.timeDifferenceChartData = {
        labels: labels,
        datasets: [
          {
            label: 'Time Difference In Hours (Incident Date and Approximate Time vs Incident Discovered Date and Time)',
            data: timeDifferencesInHours,
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgb(255, 99, 132)',
            pointStyle: 'circle',
            pointRadius: 5,
            pointHoverRadius: 10
          }
        ]
      };

      // Open the dialog that displays the chart.
      this.isTimeDifferenceChartDialogVisible = true;
    },


    getRandomColor(usedColors) {
      const chartColors = [
        'rgb(255, 99, 132)',
        'rgb(255, 159, 64)',
        'rgb(255, 205, 86)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(153, 102, 255)',
        'rgb(201, 203, 207)'
      ];
      let color = '';

      // Get colors from chart colors if not used
      for (let chartColor of chartColors) {
        if (usedColors && Array.isArray(usedColors) && usedColors.indexOf(chartColor) < 0) {
          color = chartColor;
          break;
        }
      }

      // Get random colors if all the chart colors above are already in use
      if (!color) {
        color = '#' + Math.floor(Math.random() * 16777215).toString(16);

        if (usedColors && Array.isArray(usedColors) && usedColors.indexOf(color) > -1) {
          color = this.getRandomColor(usedColors);
        }
      }

      return color;
    },

    viewIncidentReport(incidentReport) {
      // this.isIncidentReportViewDialogVisible = true;

      if (this.userState === 'Utah') {
        this.$router.push({
          path: `/incidents/${this.clientID}/update-incident/${incidentReport._id}`,
          query: {newIncident: 'false', clientNav: 'false'}
        });

      } else if (this.userState === 'Nevada') {
        this.$router.push({
          path: `/nvIncidents/${this.clientID}/update-incident/${incidentReport._id}`,
          query: {newIncident: 'false', clientNav: 'false'}
        });
      }
    },

    mapIncidents(incidents) {

      console.log({incidents});

      return incidents.map(incident => {

        incident.TimeDifference = 0;
        incident.TimeDifferenceInHours = 0;
        const rsd = moment(incident.IncidentDiscovered);

        if (rsd.isValid()) {
          const difference = moment(incident.IncidentDiscovered).diff(moment(incident.IncidentDateTime));
          const duration = moment.duration(difference);

          incident.TimeDifference = duration.asHours() === 0 ? duration.asMinutes().toFixed(2) + ' minutes' : duration.asHours().toFixed(2) + ' hours';
          incident.TimeDifferenceInHours = duration.asHours();
          incident.IncidentDiscovered = rsd.format('YYYY-MM-DD hh:mm:A');
        } else {
          incident.IncidentDiscovered = 0;
        }
        let incidentDateTime = null;

        if (incident.IncidentDateTime) {
          incidentDateTime = new moment(incident?.IncidentDateTime?.trim());
        } else {
          incidentDateTime = new moment(incident?.IncidentDate?.trim() + ' ' + incident?.IncidentTime?.trim());
        }

        if (!incidentDateTime.isValid()) {
          incidentDateTime = new moment(incident?.IncidentDate.trim());
        }

        incident.IncidentDateFormatted = moment(incident.IncidentDate).format('YYYY-MM-DD');
        incident.IncidentDateTime = incidentDateTime.format('YYYY-MM-DD hh:mm:A');

        return incident;
      });
    },

    getFilters() {
      let filters = localStorage.getItem('incidentReportGraphFilters');
      if (filters) {
        this.filters = JSON.parse(filters);
        this.clientStatus = this.filters.clientStatus;
      }
    },

    setFilters() {
      localStorage.setItem('incidentReportGraphFilters', JSON.stringify(this.filters));
    }
  }
}
</script>

<style></style>
